import fileSize from 'App/babel/helpers/fileSize';

angular.module('upFilters').filter('fileSize', function () {
	return fileSize;
});
